import { mutatorAction } from 'satcheljs';
import { getCopilotChatDrawerState, getStore } from '../store/store';

export const closeCopilotChatDrawerMutator: (targetWindow: Window) => void = mutatorAction(
    'closeCopilotChatDrawerMutator',
    (targetWindow: Window) => {
        const state = getCopilotChatDrawerState(targetWindow);
        if (!state) {
            return;
        }
        state.isShown = false;

        const store = getStore();
        const allClosed = [...store.chatDrawerStateMap.values()].every(s => !s.isShown);
        if (allClosed) {
            store.heartbeatWorkingSetSizeMb = undefined;
            store.heartbeatCommitSizeMb = undefined;
            store.isProcessShared = undefined;
        }
    }
);
